import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOpenAccessPromo } from '@/contexts/OpenAccessPromoContext';

export const ProtectedRoute = ({ children, allowExpired = false }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const { active: promoActive } = useOpenAccessPromo();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    const loginTo = promoActive ? `/login?promo=1&next=${next}` : '/login';
    return <Navigate to={loginTo} replace />;
  }

  if (!allowExpired && user?.effective_plan === 'expired' && !promoActive) {
    return <Navigate to="/plans" replace />;
  }

  return children;
};

export default ProtectedRoute;
